import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = {
  key: 0,
  type: "image/svg+xml",
  data: "https://sbp.nspk.ru/i/logo-black.svg"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", { src: "https://sbp.nspk.ru/i/logo-black.svg" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createVNode(_component_v_sheet, { class: "d-flex flex-column justify-center align-center" }, {
      default: _withCtx(() => [
        (_ctx.isSBP())
          ? (_openBlock(), _createElementBlock("object", _hoisted_5, _hoisted_7))
          : _createCommentVNode("", true),
        (_ctx.isSBP())
          ? (_openBlock(), _createBlock(_component_v_card_title, { key: 1 }, {
              default: _withCtx(() => [
                _createTextVNode("Сканируйте QR код "),
                _hoisted_8,
                _createTextVNode("в приложении Вашего банка")
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_v_card_title, { key: 2 }, {
              default: _withCtx(() => [
                _createTextVNode("QR ссылки на оплату, наведите камеру телефона")
              ]),
              _: 1
            })),
        _hoisted_9,
        (_ctx.$route.query['url'])
          ? (_openBlock(), _createBlock(_component_v_img, {
              key: 3,
              width: "260",
              src: 'https://api.qrserver.com/v1/create-qr-code/?size=260x260&data='+_ctx.$route.query['url']
            }, null, 8, ["src"]))
          : (_openBlock(), _createBlock(_component_v_card_title, {
              key: 4,
              class: "text-red-accent-2"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Нет ссылки!")
              ]),
              _: 1
            })),
        _hoisted_10,
        (!_ctx.isSBP())
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 5,
              disabled: !_ctx.$route.query['url'],
              color: "primary",
              href: _ctx.$route.query['url']
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Перейти... ")
              ]),
              _: 1
            }, 8, ["disabled", "href"]))
          : _createCommentVNode("", true),
        (_ctx.$route.query['orderId'])
          ? (_openBlock(), _createBlock(_component_v_card_title, { key: 6 }, {
              default: _withCtx(() => [
                _createTextVNode("Заказ #" + _toDisplayString(_ctx.$route.query['orderId']), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.$route.query['amount'])
          ? (_openBlock(), _createBlock(_component_v_card_title, { key: 7 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$route.query['amount']) + ",00 руб.", 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _hoisted_11,
        (_ctx.isSBP() && !!_ctx.$vuetify.display.mobile)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 8,
              disabled: !_ctx.$route.query['url'],
              color: "green",
              onClick: _ctx.openSBPWidget
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Оплатить в приложении банка ")
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]))
          : _createCommentVNode("", true),
        _hoisted_12,
        _createTextVNode(),
        _hoisted_13,
        _createVNode(_component_v_btn, { onClick: _ctx.close }, {
          default: _withCtx(() => [
            _createTextVNode(" Закрыть ")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _hoisted_14,
        _hoisted_15
      ]),
      _: 1
    })
  ]))
}